/**
 * Job-level equipment links accepted by CreateJobDto in one request
 * (`@ArrayMaxSize(20)` server-side) — callers validate against it so a long
 * selection fails in the UI instead of as a raw 400.
 *
 * Lives on its own so the small booking → job adapter can share the cap with
 * the job form without importing the form's serializer, which carries
 * route- and component-level dependencies.
 */
export const MAX_JOB_EQUIPMENT_LINKS = 20;
